import { indentSellerGroupLabel } from '@/lib/mise/sellerGroupTree';
import type { SellerTreeOption } from '@/lib/mise/sellerTree';

interface SellerTreeOptionListProps {
  options: SellerTreeOption[];
}

/**
 * 店舗を店舗グループ階層の下に並べたネイティブ <option> 群。
 * グループは見出しとして選択不可にし、店舗だけを選べるようにする。
 */
export function SellerTreeOptionList({ options }: SellerTreeOptionListProps) {
  return (
    <>
      {options.map((option, index) =>
        option.kind === 'group' ? (
          <option key={`group-${option.id}-${index}`} value="" disabled>
            {indentSellerGroupLabel(option.depth, option.label)}
          </option>
        ) : (
          <option key={option.seller.id} value={option.seller.id}>
            {indentSellerGroupLabel(option.depth, option.seller.name || option.seller.id)}
          </option>
        ),
      )}
    </>
  );
}
